import { MutationTree } from "vuex";
import { Document } from "@/types";
import { IDataProvider } from "@/store";
import { IDocumentState } from "@/store/modules/document/state";

export enum DocumentMutations {
  SET_ONE = "SET_ONE_DOCUMENT",
  SET_ALL = "SET_ALL_DOCUMENT",
  SET_LAZY_DATA = "SET_LAZY_DATA_DOCUMENT",
  SET_FILE = "SET_FILE_DOCUMENT",
}

export const mutations: MutationTree<IDocumentState> = {
  [DocumentMutations.SET_ONE](state, payload: Document) {
    state.document = payload;
  },
  [DocumentMutations.SET_ALL](state, payload: Document[]) {
    state.documents = payload;
  },
  [DocumentMutations.SET_LAZY_DATA](state, payload: IDataProvider<Document>) {
    state.dataProvider = payload;
  },
  [DocumentMutations.SET_FILE](state, payload: Blob) {
    state.file = payload;
  },
};
